import React, { useEffect, useState } from 'react';
import { Select } from 'tea-component';
import { useIntl } from 'umi';
import { useFilterOptionList } from '@/pages/intelligence/hooks/useFilterOptionList';

export default function SelectContext(props: any) {
  const { formatMessage } = useIntl();
  const { value: defaultValue, onConfirm } = props;
  const [plan, setPlan] = useState(defaultValue || 'All');
  const { planOptionFilterOptions } = useFilterOptionList({ formatMessage });
  useEffect(() => {
    setPlan(defaultValue || 'All');
  }, [defaultValue]);

  return (
    <Select
      className="select-item"
      appearance="button"
      options={planOptionFilterOptions}
      value={plan}
      matchButtonWidth
      onChange={(value) => {
        setPlan(value);
        if (onConfirm instanceof Function) {
          onConfirm(value);
        }
      }}
      button={(option) => (
        <div className="dbi-select-button">
          <div className="select-button-text">
            {formatMessage({ id: 'dbi_top_plan' })}
          </div>
          <span className="select-button-value">
            {
              planOptionFilterOptions.filter((e) => {
                return e.value == plan;
              })[0]?.text
            }
          </span>
        </div>
      )}
    />
  );
}
